import { Link } from "react-router-dom";
import SubmitButton from "../../assets/inputs/SubmitButton";
import TextInput from "../../assets/inputs/TextInput";
import Logo from "../../assets/Logo";
import InstagramIcon from "../../icons/InstagramIcon";
import LinkedinIcon from "../../icons/LinkedinIcon";
import XIcon from "../../icons/XIcon";
import FacebookIcon from "../../icons/FacebookIcon";
import TiktokIcon from "../../icons/TiktokIcon";
import YoutubeIcon from "../../icons/YoutubeIcon";

function FooterNavLink({
    children,
    href
}) {
    return (
        <li className="font-[600] text-large small-computer:text-regular tablet:text-heading-6 tablet:text-center tablet:text-balance transition-all hover:opacity-50">
            <Link to={href}>
                {children}
            </Link>
        </li>
    )
}

function FooterNavTitle({
    children
}) {
    return (
        <h2 className="text-heading-5 tablet:text-heading-3 font-bold">
            {children}
        </h2>
    )
}

export default function Footer() {
    const socials = [
        {
            href: "https://www.instagram.com/zoeil.agence/",
            icon: <InstagramIcon/>
        },
        {
            href: "https://www.linkedin.com/company/zoeil",
            icon: <LinkedinIcon/>
        },
        {
            href: "https://x.com/zoeil_agence",
            icon: <XIcon/>
        },
        {
            href: "https://www.facebook.com/profile.php?id=61565973510866",
            icon: <FacebookIcon/>
        },
        {
            href: "http://www.tiktok.com/@zoeil.agence",
            icon: <TiktokIcon/>
        },
        {
            href: "https://www.youtube.com/@zoeil.agence",
            icon: <YoutubeIcon/> 
        }
    ]

    return (
        <footer>
            <div className="max-w-[1660px] w-full flex justify-between mx-auto py-[5rem] tablet:flex-col px-3 tablet:px-6 tablet:items-center tablet:justify-start tablet:gap-[8rem]">
                <div className="flex flex-col gap-[2.125rem] tablet:items-center">
                    <div className=" text-zoeil-blue max-w-[180px]">
                        <Logo />
                    </div>
                    <div className="text-very-large font-bold tablet:text-center mobile:text-heading-4">
                        Voir plus loin ensemble
                    </div>
                </div>
                <div className="flex flex-col tablet:items-center">
                    <FooterNavTitle>
                        Navigation
                    </FooterNavTitle>
                    <ul className="tablet:flex tablet:flex-col tablet:items-center">
                        <FooterNavLink href={"/"}>
                            Accueil
                        </FooterNavLink>
                        <FooterNavLink href={"/services"}>
                            Nos services
                        </FooterNavLink>
                        <FooterNavLink href={"/realisations"}>
                            Nos Réalisations
                        </FooterNavLink>
                        <FooterNavLink href={"/about"}>
                            A propos de Zoeil
                        </FooterNavLink>
                        <FooterNavLink href={"/contact"}>
                            Contact
                        </FooterNavLink>
                    </ul>
                </div>
                <div className="flex flex-col tablet:items-center">
                    <FooterNavTitle>
                        Contact
                    </FooterNavTitle>
                    <ul className="tablet:flex tablet:flex-col tablet:items-center">
                        <FooterNavLink>
                            Tél : 06 12 81 75 26
                        </FooterNavLink>
                        <FooterNavLink>
                            Email : contact@zoeil-agence.com
                        </FooterNavLink>
                        <FooterNavLink>
                            36 rue des Tilleuls, 59650, Villeneuve d’ascq
                        </FooterNavLink>
                    </ul>
                </div>
                <div className="flex flex-col w-full max-w-[320px] gap-[1.5625rem]">
                    <div className="tablet:flex tablet:flex-col tablet:items-center">
                        <FooterNavTitle>
                            Newsletter
                        </FooterNavTitle>
                        <p>
                            Ne manque aucune actu !
                        </p>
                    </div>
                    <form className="flex flex-col gap-[1.5625rem]">
                        <TextInput
                        type="email"
                        required
                        placeholder="email@exemple.fr"
                        className="!text-regular !px-[1.25rem] !py-[1rem]"/>
                        <SubmitButton>
                            S'abonner
                        </SubmitButton>
                    </form>
                </div>
            </div>
            <div className="bg-zoeil-grey min-h-[100px] flex flex-col justify-center mobile:py-16">
                <div className="max-w-[1660px] px-3 mx-auto w-full tablet:px-10 flex items-center justify-between text-large mobile:flex-col-reverse mobile:gap-[3.125rem] mobile:text-very-large">
                    <div>
                    © Copyright Zœil 2024
                    </div>
                    <Link className="underline transition-all hover:text-zoeil-blue" to={"/politique-de-confidentialite"}>
                        Politique de confidentialité
                    </Link>
                    <div className="flex items-center gap-[1rem]">
                        {socials.map(social=>
                            <a href={social.href} target="_blank" className="block w-[24px] aspect-square transition-all hover:text-zoeil-blue">
                                {social.icon}
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    )
}